module.exports = __webpack_public_path__ + "img/ai_writing.3839dc75.png";